module.exports = __webpack_public_path__ + "static/media/DaxlinePro-Bold.2264b8f7.woff";